import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
export function Philosophy() {
  const {
    t
  } = useLanguage();
  return <section id="filosofia" className="bg-kinetic-alt py-16 md:py-24 px-5 sm:px-6" data-id="element-179" data-mp="3dxfdfs5lcjrl">
      <div className="container mx-auto" data-id="element-180" data-mp="305h71p39l1z4">
        <span className="text-xs text-cyan-400 uppercase tracking-widest" data-id="element-181" data-mp="304pp3h2lb2rb">
          ● {t.philosophy_label}
        </span>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-10 md:gap-12 mt-6" data-id="element-182" data-mp="2q8mbnf2afhp2">
          <div className="md:col-span-3" data-id="element-183" data-mp="2qap9gl9omf4c">
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-black text-white" data-id="element-184" data-mp="2v8igfgit7d5o">
              {t.philosophy_heading}
            </h2>
            <div className="w-12 h-0.5 bg-cyan-400/40 my-6 sm:my-8" data-id="element-185" data-mp="2ha0zc1nesywq" />
            <p className="text-white/60 text-sm sm:text-base" data-id="element-186" data-mp="2m7attvpno0rf">{t.philosophy_p1}</p>
            <p className="text-white/60 mt-4 text-sm sm:text-base" data-id="element-187" data-mp="fhmiz70ik2if">{t.philosophy_p2}</p>
            <span className="block text-white/20 text-2xl tracking-widest mt-6 sm:mt-8" data-id="element-188" data-mp="kfnyjhyqdjp5">
              · · ·
            </span>
          </div>

          <div className="md:col-span-2" data-id="element-189" data-mp="179bcd6s4o8rn">
            {t.philosophy_principles.map((item, index) => <div key={item} className="flex items-center border-b border-white/[0.08] py-4 sm:py-5 group" data-id="element-190" data-mp="137zx9v6vr5xp" data-mpi={index}>
                <span className="text-cyan-400/60 text-sm mr-4 sm:mr-6 shrink-0" data-id="element-191" data-mp="1c35xmendsvsu">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <span className="text-white/80 text-base sm:text-lg group-hover:text-white transition-colors" data-id="element-192" data-mp="kayhdfbsflez">
                  {item}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}